const GSI_SRC = 'https://accounts.google.com/gsi/client';

let loadPromise: Promise<void> | null = null;

const isReady = (): boolean => Boolean(window.google?.accounts?.oauth2);

const loadGoogleIdentityServices = (): Promise<void> => {
  if (isReady()) {
    return Promise.resolve();
  }

  if (loadPromise) {
    return loadPromise;
  }

  loadPromise = new Promise<void>((resolve, reject) => {
    const onError = () => {
      loadPromise = null;
      reject(new Error('Failed to load Google Identity Services'));
    };

    const existing = document.querySelector<HTMLScriptElement>(`script[src="${GSI_SRC}"]`);
    if (existing) {
      existing.addEventListener('load', () => resolve());
      existing.addEventListener('error', onError);
      if (isReady()) resolve();
      return;
    }

    const script = document.createElement('script');
    script.src = GSI_SRC;
    script.async = true;
    script.defer = true;
    script.onload = () => resolve();
    script.onerror = onError;
    document.head.appendChild(script);
  });

  return loadPromise;
};

export default loadGoogleIdentityServices;
